(function () {

	var eventCarousels = document.querySelectorAll('[data-events]');

	if (!eventCarousels.length) return;

	for (var i = 0; i < eventCarousels.length; i++) {
		(function (i) {

			setupEventsCarousel(eventCarousels[i]);

		}).call(this, i);
	}

	function setupEventsCarousel(eventContainer) {

		var tnsInstance = tns({
			container: eventContainer,
			slideBy: 'page',
			mouseDrag: true,
			controls: true,
			nav: true,
			items: 1,
			loop: false,
			preventScrollOnTouch: 'auto',
			swipeAngle: 30,
			controlsPosition: 'top',
			navPosition: 'bottom',
			responsive: {
				640: {
					items: 2
				},
				900: {
					items: 3
				}
			}
		});

		tnsInstance.events.on('transitionEnd', function () {
			changeAriaAttributes(eventContainer);
			applyBlurEffect(eventContainer);
		});

		changeAriaAttributes(eventContainer);
		applyBlurEffect(eventContainer);

		const slideLinks = eventContainer.querySelectorAll('.js-event-link');

		for (var i = 0; i < slideLinks.length; i++) {
			(function (i) {
				slideLinks[i].addEventListener('focus', () => {
					tnsInstance.goTo(i);
				});
			}).call(this, i);

		}

	};

	function changeAriaAttributes(eventContainer) {

		const items = eventContainer.querySelectorAll('.tns-item');

		if (!items.length) return;

		for (var i = 0; i < items.length; i++) {
			(function (i) {

				items[i].removeAttribute('aria-hidden');
				items[i].removeAttribute('tabindex');

			}).call(this, i);

		}

	}

	function applyBlurEffect(eventContainer) {
		const innerContainer = eventContainer.closest('.tns-inner');
		const items = eventContainer.querySelectorAll('.tns-item');

		if (!innerContainer || !items.length) return;

		for (var i = 0; i < items.length; i++) {
			if (isSlideInView(items[i], innerContainer)) {
				items[i].classList.remove('is-blurred');
			} else {
				items[i].classList.add('is-blurred');
			}
		}
	}

	function isSlideInView(slide, container) {
		const slideRect = slide.getBoundingClientRect();
		const containerRect = container.getBoundingClientRect();
		const buffer = 1;
	
		return (
			slideRect.left >= containerRect.left - buffer &&
			slideRect.right <= containerRect.right + buffer
		);
	}

})();
